// Stub of the legacy analytics module (GUNDI-5639, dual-UI trial).
//
// The legacy tree is a frozen copy of e4ae89c and its call sites are left
// verbatim, but the trial ships NO analytics from the legacy UI: its page
// titles and event names predate the Connection→Route rename, so mixing them
// into GA4 would corrupt the new UI's reports. Every export here is a no-op
// with the original signature. The shell owns ReactGA.initialize.
export function getUserType(email: string): "internal" | "external" {
    return email?.endsWith("@earthranger.com") ? "internal" : "external";
}

export function getPageTitle(pathname: string): string {
    return pathname;
}

export async function setAnalyticsUserProperties(token: string) { }
export function trackPageView(path: string, title: string) { }
export function trackConnectionCreationStarted(workspaceName?: string) { }
export function trackConnectionCreated(connectionId?: string, providerType?: string, workspaceName?: string) { }
export function trackConnectionCreationAbandoned(lastStep: number, providerType?: string, workspaceName?: string) { }
export function trackConnectionEnabled(connectionId?: string, providerType?: string, workspaceName?: string) { }
export function trackConnectionDisabled(connectionId?: string, providerType?: string, workspaceName?: string) { }
export function trackDestinationAdded(connectionId?: string, destinationType?: string, workspaceName?: string) { }
export function trackDestinationUpdated(destinationId?: string, destinationType?: string, workspaceName?: string) { }
export function trackDestinationCreationStarted() { }
export function trackDestinationCreationAbandoned(destinationType?: string, workspaceName?: string) { }
export function trackHelpPanelOpened() { }
export function trackHelpArticleClicked(articleTitle: string, url: string) { }
export function trackHelpSupportCenterClicked() { }
export function trackHelpContactClicked() { }
export function trackAccountProfileUpdated() { }
export function trackAccountWorkspaceLeft(workspaceName?: string) { }
